
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_493_1031)"}},[_c('path',{attrs:{"d":"M10.002 0C4.478 0 0 4.478 0 10.002c0 5.524 4.478 10.002 10.002 10.002 5.524 0 10.002-4.478 10.002-10.002C20 4.478 15.522 0 10.002 0zm.967 13.362c-.907-.071-1.29-.521-2.002-.953-.39 2.056-.87 4.024-2.288 5.052-.439-3.105.641-5.438 1.144-7.913-.855-1.44.101-4.335 1.905-3.623 2.22.878-1.924 5.352.859 5.91 2.903.586 4.088-5.036 2.288-6.862-2.6-2.64-7.568-.06-6.957 3.716.15.923 1.102 1.204.382 2.48-1.665-.368-2.16-1.68-2.096-3.432.101-2.865 2.573-4.872 5.052-5.15 3.135-.352 6.075 1.152 6.484 4.1.454 3.33-1.418 6.934-4.77 6.675z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_493_1031"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    